export default "__VITE_ASSET__B7IAQt3i__"